import React from 'react';
import Feature from '../../common/Feature';
import config from '../../../config'

const Security = () => {
	return (
		<section className="row features" id="security">
			<div className="col">
				<h2 className="title">Rugged Security</h2>
			</div>
			<div className="callouts">
				<Feature
					title="Master Lock Security Built In"
					description="Advanced locking technology that resists both physical attacks and lock manipulation."
					image={`${config.contentUrl}/sentrysafe/features/FP_MasterLockBuiltIn.png`}
				/>
				<Feature
					title="Metal Handle Design" r
					description="Integrated handle provides secure yet simple access."
					image={`${config.contentUrl}/sentrysafe/features/FP_MetalHandle.png`}
				/>
				<Feature
					title="Pry-resistant Hinge Bar"
					description="Pry-resistant hinge bar reinforces the door of the safe for added protection against theft."
					image={require('../../../resources/img/features/pry-resistant-door.png')}
				/>
				<Feature
					title="Tethering Cable"
					description="Steel tethering cable allows you to attach your safe to fixed objects for added security while traveling."
					image={require('../../../resources/img/features/tether-cable.png')}
				/>
				<Feature
					title="Steel Construction"
					description="Solid steel construction for durable and reliable protection."
					image={require('../../../resources/img/features/steel-construction.png')}
				/>
				<Feature
					title="Anti-Fish Hopper"
					description="Anti-fish hoppers prevent cash and deposits from being stolen with extendable tools or hooked wires."
					image={require('../../../resources/img/features/anti-fish-hopper.png')}
				/>
				<Feature
					title="Compression Gas Strut"
					description="Automatic door opening when your safe is unlocked for fast, quiet, and discreet entry."
					image={require('../../../resources/img/features/quick-entry.png')}
				/>
				<Feature
					title="Live-Locking Bolts"
					description="Live-locking bolts provide advanced protection against theft and unauthorized users."
					image={require('../../../resources/img/features/bolt.png')}
				/>
				<Feature
					title="Concealed Hinges"
					description="Offers added protection against attempted break-ins."
					image={require('../../../resources/img/features/hinge.png')}
				/>
				<Feature
					title="Mounting Hardware"
					description="Ensures your small safe is securely attached in order to prevent it from being physically moved or stolen."
					image={require('../../../resources/img/features/mounting-hardware.png')}
				/>
				<Feature
					title="Anti-Drill Door"
					description="Features a relocking device that helps protect against drill attacks."
					image={require('../../../resources/img/features/anti-drill.png')}
				/>
			</div>
		</section>
	);
};

export default Security;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Security.js